import { SeoPageType } from "../enums";
import { ROUTE_MAP } from "./routers";

export const SeoPageUrlMap: Record<SeoPageType, string> = {
  [SeoPageType.Home]: ROUTE_MAP.home,
  [SeoPageType.Product]: ROUTE_MAP.product.detail,
};
